module.exports = __webpack_public_path__ + "media/images/footLogo-e3ab7e617dd231c2fd30e441a15a7da4.png";